// import 'babel-polyfill';
// import "isomorphic-fetch"
import './language';
import './fieldLength';
import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Router, HashRouter, Route, Switch } from 'react-router-dom';

import AuthenRoute from './components/AuthenRoute';
import { Label } from './components/FormControl';
import ReactLoading from 'react-loading';

import { loginInfo, history } from './global';

import RNListener from './reactNativeListener';

// Styles
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import '../scss/style.scss'
// Temp fix for reactstrap
import '../scss/core/_dropdown-menu-right.scss'
import "react-table/react-table.css";
import 'sweetalert2/src/sweetalert2.scss'

import 'devextreme/dist/css/dx.common.css';
// import 'devextreme/dist/css/dx.light.compact.css';
// import 'devextreme/dist/css/dx.light.css';
import 'devextreme/dist/css/dx.material.blue.light.css';

//import fonts
import WebFont from 'webfontloader';
WebFont.load({
  google: {
    families: ['Open+Sans:300,400,600,700', 'sans-serif']
  }
});

// Containers
// import Full from './containers/Full/Full'

const Full = lazy(() => import('./containers/Full/Full'));


// import FullKiosk from './containers/Full/Full.Kiosk'
// import FullKiosk from './containers/Full/Full.Kiosk.v2'
// import FullKiosk from './containers/Full/Full.Kiosk.v3'
const FullKiosk = React.lazy(() => import('./containers/Full/Full.Kiosk.v3'));

import EmailDirectCtrl from './containers/Master/EmailDirect'
import LoginCtrl from './containers/Master/Login'
import Register from './views/Pages/Register/'
import MenuCtrl from './views/Home/Home.Menu'

//get the config from index.html file
loginInfo.host = window.host;
for (var pro in window.loginInfo) {
  loginInfo[pro] = window.loginInfo[pro];
}
window.rootElement = document.getElementById('root');

//console.log(loginInfo);
// window.onkeydown = (e) => { if (e.keyCode == 32) debugger; };


// document.documentElement.style.overflow = 'hidden';
// document.body.style.overflow = 'hidden';
// document.html.style.overflow = 'hidden'; 
// document.body.style.position = 'relative'; 

// document.body.ontouchend = (e) => { 
//   e.preventDefault();
// };

// window.addEventListener('scroll', function(e) { 
//   // alert("Scrolled"); 
//   e.preventDefault();
// });

ReactDOM.render((
  <div>
    <RNListener />
    <Suspense fallback={
      <div style={{ position: 'fixed', top: '50%', left: '50%', marginLeft: '-40px', marginTop: '-70px', textAlign: 'center' }}>
        <ReactLoading
          type="spin" color="#20a8d8" height={100} width={80} />
        <div style={{ marginTop: '-10px', fontSize: '15px' }}><Label>Loading</Label>...</div>
      </div>}>
      <Router history={history}>
        <Switch>
          <Route path="/EmailDirect" name="EmailDirect" component={EmailDirectCtrl}/>
          <Route path="/login" name="Login" component={LoginCtrl} />
          <Route path="/register" name="Register Page" component={Register} />
          <Route path="/menu" name="Menu" component={MenuCtrl} />
          <Route path="/Kiosk" name="Home" component={FullKiosk} />
          <AuthenRoute path="/" name="Home" component={Full} />
        </Switch>
      </Router>
    </Suspense>
  </div>
), window.rootElement);



// WEBPACK FOOTER //
// ./src/index.js